import React from "react";

/**
 * Reusable MarketVyne logo.
 *
 * The source asset is the full-color "dark-bg" wordmark (white "Market" +
 * lime-green "Vyne" + icon mark on a transparent background). It is designed
 * to sit on the brand-dark navbar — do NOT place on a white background.
 *
 * Variants:
 *  - "full"  : icon + wordmark (default; for header / footer)
 *  - "mark"  : icon-only fallback (favicon-size, mobile compact contexts)
 *
 * Sizing: pass `height` (in px). Width auto-scales via aspect ratio (~4.3:1
 * for full, ~1:1 for mark). Never apply `w-full` or fixed widths that would
 * stretch or crop the lockup.
 */
export const Logo = ({ variant = "full", height = 32, className = "", linkTitle = "MarketVyne" }) => {
  const src = variant === "mark" ? "/marketvyne-logo-sm.png" : "/marketvyne-logo.png";
  const srcSet = variant === "mark"
    ? undefined
    : "/marketvyne-logo.png 1x, /marketvyne-logo@2x.png 2x";

  return (
    <img
      src={src}
      srcSet={srcSet}
      alt="MarketVyne"
      title={linkTitle}
      height={height}
      style={{ height: `${height}px`, width: "auto" }}
      className={`select-none ${className}`}
      data-testid={`logo-${variant}`}
      draggable={false}
    />
  );
};

export default Logo;
